import React from 'react';
import { IIcon } from './types';

const SVG = ({ width = '2rem', style, testId }: IIcon) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 20 20"
    data-testid={testId}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}>
    <rect x="5" y="5" width="11" height="10" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3621 0.159838C13.0404 1.34164 15.4991 1.89244 18.1 1.89244H19V9.12663C19 17.889 10.2833 19.9369 10.1951 19.9558L10 20L9.80488 19.9558C9.71668 19.9369 1.00001 17.889 1 9.12663V1.89244H1.9C4.50092 1.89244 6.95959 1.34164 9.63789 0.159838L10 0L10.3621 0.159838ZM14.8146 6.51095C14.4171 6.21153 13.8534 6.29263 13.5552 6.69198L9.45244 12.1865L7.03633 9.7598C6.68488 9.40678 6.11512 9.40679 5.76367 9.7598C5.41223 10.1129 5.41229 10.6854 5.76367 11.0385L8.27119 13.5588C8.99732 14.2884 10.1986 14.2023 10.8147 13.3769L14.9948 7.7764C15.2928 7.37689 15.2122 6.81053 14.8146 6.51095Z"
      fill="#E3BC64"
    />
  </svg>
);

export default SVG;
